import React, { useEffect, useRef, useState } from "react";
import { useAiChat, ChatMessages } from "./AiChatParts";
import "./AiAnalyst.css";

/**
 * AI Analyst — full-page chat with the product data.
 *
 * Ephemeral conversations: full history lives in the useAiChat hook and is
 * re-sent to the backend on every turn. Shares its chat engine and message
 * rendering with the floating widget (AiChatWidget.js) via AiChatParts.js.
 */

const SUGGESTIONS = [
	"How is DAU trending over the last 14 days? Show a chart.",
	"Which users were active yesterday but are missing today?",
	"Which workspaces used the copilot the most this month?",
	"Which workspaces are most active in chat this week?",
];

const AiAnalyst = () => {
	const chat = useAiChat();
	const [input, setInput] = useState("");
	const bottomRef = useRef(null);

	useEffect(() => {
		bottomRef.current?.scrollIntoView({ behavior: "smooth" });
	}, [chat.messages, chat.streamingText, chat.toolEvents]);

	useEffect(() => () => chat.abortRef.current?.abort(), []); // eslint-disable-line react-hooks/exhaustive-deps

	const submit = (text) => {
		chat.send(text ?? input);
		setInput("");
	};

	return (
		<div className="ai-analyst-page">
			<div className="ai-analyst-header">
				<h1>AI Analyst</h1>
				<p>Ask business questions against live product data</p>
				{chat.messages.length > 0 && (
					<button className="ai-clear-btn" onClick={chat.clear} disabled={chat.isLoading}>
						New chat
					</button>
				)}
			</div>

			<div className="ai-chat-scroll">
				<ChatMessages
					chat={chat}
					suggestions={SUGGESTIONS}
					onSuggestion={submit}
					bottomRef={bottomRef}
					emptyState={
						<>
							<div className="ai-empty-icon">📊</div>
							<h2>What do you want to know?</h2>
						</>
					}
				/>
			</div>

			<div className="ai-composer">
				<textarea
					value={input}
					onChange={(e) => setInput(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter" && !e.shiftKey) {
							e.preventDefault();
							submit();
						}
					}}
					placeholder="e.g. Which users were active yesterday but are missing today?"
					rows={1}
					disabled={chat.isLoading}
				/>
				{chat.isLoading ? (
					<button className="ai-send-btn stop" onClick={chat.stop}>
						Stop
					</button>
				) : (
					<button className="ai-send-btn" onClick={() => submit()} disabled={!input.trim()}>
						Send
					</button>
				)}
			</div>
		</div>
	);
};

export default AiAnalyst;
